import React, {Component} from 'react'
import PropTypes from 'prop-types'
import isEqual from 'lodash/isEqual'
import innerText from 'react-innertext'
import Analytics from '../'

const withAnalyticsOnBlur = WrappedComponent =>
  class extends Component {
    static propTypes = {
      input: PropTypes.shape({
        name: PropTypes.string,
        onBlur: PropTypes.func
      }).isRequired,
      meta: PropTypes.shape({error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])}).isRequired,
      label: PropTypes.any,
      exposeValue: PropTypes.bool.isRequired
    }

    static defaultProps = {
      label: '',
      exposeValue: false
    }

    static displayName = `${WrappedComponent.displayName}WithAnalyticsOnBlur`

    constructor(props) {
      super(props)

      this.analytics = new Analytics(props.analytics)
      this.state = {
        previousValue: undefined
      }
    }

    componentDidUpdate(prevProps) {
      if (
        prevProps.analytics &&
        !isEqual(prevProps.analytics.contexts, this.props.analytics.contexts)
      ) {
        this.analytics = new Analytics(this.props.analytics)
      }

      if (prevProps.meta.visited !== this.props.meta.visited) {
        this.setState({
          previousValue: this.props.input.value
        })
      }
    }

    onBlur = event => {
      const {input: {onBlur}} = this.props

      onBlur(event)

      setTimeout(() => {
        const {
            input: {name, value},
            meta: {touched, error},
            label,
            exposeValue
          } = this.props,
          { previousValue } = this.state,
          field = {
            name,
            label: innerText(label),
            error: touched && error || null
          }

        // Expose user input user when needed
        if (exposeValue) {
          Object.assign(field, {value: `${value}`})
        }

        if (previousValue !== value) {
          this.analytics.event(field)
        }

        this.setState({
          previousValue: value
        })
      }, 0)
    }

    render() {
      const {input, ...props} = this.props

      return (
        <WrappedComponent input={{...input, onBlur: this.onBlur}} {...props}/>
      )
    }
  }

export default withAnalyticsOnBlur
